export const CLOUDINARY_CLOUD = process.env.REACT_APP_CLOUDINARY_CLOUD;
export const CLOUDINARY_PRESET = process.env.REACT_APP_CLOUDINARY_PRESET;

/**
 * Basic URL builder with optional compression
 */
export const cloudinaryUrl = (path, options = {}) => {
  if (!path) return "";
  const trimmed = path.trim();
  if (trimmed.startsWith("http://") || trimmed.startsWith("https://"))
    return trimmed;

  // Apply default compression if not specified
  const {
    quality = 80,
    format = "auto",
    width = null,
    height = null,
  } = options;

  let transformation = `q_${quality},f_${format}`;
  if (width) transformation += `,w_${width}`;
  if (height) transformation += `,h_${height}`;

  const localPath = trimmed.startsWith("/") ? trimmed : `/${trimmed}`;
  return `https://res.cloudinary.com/${CLOUDINARY_CLOUD}/image/upload/${transformation}${localPath}`;
};

/**
 * Get compressed property image URL for different display sizes
 * Returns optimized image for the specified use case
 */
export const getPropertyImageUrl = (publicId, size = "medium") => {
  if (!publicId) return "";

  const sizes = {
    thumbnail: {
      width: 150,
      height: 150,
      quality: 70,
      crop: "fill",
    },
    small: {
      width: 300,
      height: 300,
      quality: 75,
      crop: "fill",
    },
    medium: {
      width: 600,
      height: 600,
      quality: 80,
      crop: "fill",
    },
    large: {
      width: 1200,
      height: 1200,
      quality: 85,
      crop: "fill",
    },
  };

  const config = sizes[size] || sizes.medium;
  const transformation = `c_${config.crop},g_auto,h_${config.height},w_${config.width},q_${config.quality},f_auto`;

  const localPath = publicId.startsWith("/") ? publicId : `/${publicId}`;
  return `https://res.cloudinary.com/${CLOUDINARY_CLOUD}/image/upload/${transformation}${localPath}`;
};

/**
 * Get compressed profile picture URL
 * Optimized for avatar/profile display
 */
export const getProfileImageUrl = (publicId, size = "medium") => {
  if (!publicId) return "";

  const sizes = {
    small: { size: 100, quality: 75 },
    medium: { size: 200, quality: 80 },
    large: { size: 400, quality: 85 },
  };

  const config = sizes[size] || sizes.medium;
  const transformation = `c_thumb,g_face,h_${config.size},w_${config.size},q_${config.quality},f_auto,r_max`;

  const localPath = publicId.startsWith("/") ? publicId : `/${publicId}`;
  return `https://res.cloudinary.com/${CLOUDINARY_CLOUD}/image/upload/${transformation}${localPath}`;
};

/**
 * Apply automatic quality and format optimization
 * Lets Cloudinary decide the best quality and format
 */
export const getOptimizedImageUrl = (publicId, width = null, height = null) => {
  if (!publicId) return "";

  let transformation = "q_auto,f_auto";
  if (width) transformation += `,w_${width}`;
  if (height) transformation += `,h_${height}`;

  const localPath = publicId.startsWith("/") ? publicId : `/${publicId}`;
  return `https://res.cloudinary.com/${CLOUDINARY_CLOUD}/image/upload/${transformation}${localPath}`;
};
